import { render, staticRenderFns } from "./goodsgroup.vue?vue&type=template&id=d7b1d74e&scoped=true"
import script from "./goodsgroup.vue?vue&type=script&lang=js"
export * from "./goodsgroup.vue?vue&type=script&lang=js"
import style0 from "./goodsgroup.vue?vue&type=style&index=0&id=d7b1d74e&prod&lang=css"
import style1 from "./goodsgroup.vue?vue&type=style&index=1&id=d7b1d74e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b1d74e",
  null
  
)

export default component.exports